import type { Breadcrumb, Scope, SeverityLevel } from '@sentry/react';

type SentryModule = typeof import('@sentry/react');

let sentryPromise: Promise<SentryModule> | null = null;

export const getSentry = () => {
  if (!sentryPromise) {
    sentryPromise = import('@sentry/react');
  }

  return sentryPromise;
};

export const addSentryBreadcrumb = (breadcrumb: Breadcrumb) => {
  if (process.env.NODE_ENV !== 'production') return;
  void getSentry().then((Sentry) => Sentry.addBreadcrumb(breadcrumb));
};

export const captureSentryMessage = (
  message: string,
  captureContext?: SeverityLevel
) => {
  if (process.env.NODE_ENV !== 'production') return;

  void getSentry().then((Sentry) =>
    Sentry.captureMessage(message, captureContext)
  );
};

export const withSentryScope = (
  callback: (scope: Scope, Sentry: SentryModule) => void
) => {
  if (process.env.NODE_ENV !== 'production') return;

  void getSentry().then((Sentry) => {
    Sentry.withScope((scope) => callback(scope, Sentry));
  });
};
